export const MIN_VEHICLE_YEAR = 1990;

export const getVehicleYears = (currentYear = new Date().getFullYear()) => (
  Array.from(
    { length: currentYear - MIN_VEHICLE_YEAR + 2 },
    (_, index) => MIN_VEHICLE_YEAR + index
  )
);
